module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/heart-708d7cf364cc9b150182db0145282d32.svg";